<template>
  <PoolEditorModal
    v-if="launcher.isOpen"
    :key="launcher.poolId ?? 'new'"
    :poolId="launcher.poolId ?? null"
    @closed="onClosed"
  />
</template>

<script setup lang="ts">
import PoolEditorModal from "@/forwards2/pools/PoolEditorModal.vue";
import { usePoolEditorLauncher } from "@/forwards2/pools/usePoolEditorLauncher";
import { onBeforeUnmount } from "vue";

/**
 * Renders the pool editor modal whenever `usePoolEditorLauncher` has a pool open. Each page that
 * shows pool links mounts one and reloads what it shows on `written`. Leaving the page closes the
 * editor, or the next page with a host would open on it — before the next page mounts, hence
 * `onBeforeUnmount`.
 */
const emit = defineEmits<{
  /** An editing session saved, archived, unarchived or deleted a pool. */
  written: [];
}>();

const launcher = usePoolEditorLauncher();

const onClosed = (written: boolean) => {
  launcher.close();
  if (written) emit("written");
};

onBeforeUnmount(() => {
  if (launcher.isOpen) launcher.close();
});
</script>
